import { TableAction } from "antd/es/table/interface";
import { getUserTableData } from "../../modules/Admin/admin.service";
import { UserTableData } from "../../modules/Admin/model";
import { TableTypes } from "../../modules/ManageContract/constants";
import {
  BulkClauseTableData,
  BulkSummaryTableData,
  ContractTableData,
  DraftingTableData,
  RfxEvaluationTableData,
  WorkBenchTableData,
} from "../../modules/ManageContract/model";
import {
  getClausesForBulkSummaryTable,
  getClausesForBulkUploadTable,
  getContractsForTable,
  getDraftingContractsForTable,
  getRfxEvaluationDataForTable,
  getWorkBenchDataForTable,
} from "../../services/common.service";
import { GeneratedRfxTableData } from "../../modules/ManageContract/model";
import { getGeneratedRfxContractsForTable } from "../../services/common.service";

export const TableActions = {
  SET_STATE: "SET_STATE",
  UPDATE_SORT_CONFIG: "UPDATE_SORT_CONFIG",
  RESET_STATE: "RESET_STATE",
  UPDATE_SHOW_RECENT: "UPDATE_SHOW_RECENT",
};

export const UPDATE_WORKBENCH_DATA = 'UPDATE_WORKBENCH_DATA';



const entityMapper: any = {
  [TableTypes.RFX_GENERATOR_DASHBOARD]: {
    listApi: getGeneratedRfxContractsForTable,
    dataObject: GeneratedRfxTableData,
  },
  [TableTypes.RFX_EVALUATION_DASHBOARD]: {
    listApi: getRfxEvaluationDataForTable,
    dataObject: RfxEvaluationTableData,
  },
  [TableTypes.DRAFTING_DASHBOARD]: {
    listApi: getDraftingContractsForTable,
    dataObject: DraftingTableData,
  },
  [TableTypes.REVIEW_PENDING_DASHBOARD]: {
    listApi: getContractsForTable,
    dataObject: ContractTableData,
  },
  [TableTypes.REVIEW_PENDING]: {
    listApi: getContractsForTable,
    dataObject: ContractTableData,
  },
  [TableTypes.REVEIW_COMPLETED]: {
    listApi: getContractsForTable,
    dataObject: ContractTableData,
  },
  [TableTypes.BULK_CLAUSE_DASHBOARD]: {
    listApi: getClausesForBulkUploadTable,
    dataObject: BulkClauseTableData,
  },
  [TableTypes.BULK_CLAUSE]: {
    listApi: getClausesForBulkUploadTable,
    dataObject: BulkClauseTableData,
  },
  [TableTypes.BULK_SUMMARY]: {
    listApi: getClausesForBulkSummaryTable,
    dataObject: BulkSummaryTableData,
  },
  [TableTypes.USER_MANAGEMENT]: {
    listApi: getUserTableData,
    dataObject: UserTableData,
  },
  [TableTypes.workBenchDashboard]: {
    listApi: getWorkBenchDataForTable,
    dataObject: WorkBenchTableData,
  },
};

export const resetTableState = (entity: string) => {
  return async (dispatch: any) => {
    dispatch({
      type: TableActions.RESET_STATE,
      payload: {
        entity: entity,
        entityData: {
          loading: true,
          tableData: {},
        },
      },
    });
  };
};

export const setTableConfigThunk = (entity: string, tableConfig: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: TableActions.SET_STATE,
      payload: {
        entity: entity,
        entityData: {
          tableConfig: tableConfig,
        },
      },
    });
  };
};

export const getTableDataThunk = (
  entity: string,
  pageNumber: number,
  count: number,
  apiProps?: {},
  onSuccess?: any
) => {
  return async (dispatch: any, getState: any) => {
    if (!getState()?.rootReducer?.tableInfoReducer?.data?.[entity]?.tableData) {
      dispatch({
        type: TableActions.SET_STATE,
        payload: {
          entity: entity,
          entityData: {
            loading: true,
            error: false,
            toBeRetrieved: count,
            page: pageNumber,
          },
        },
      });
    } else {
      dispatch({
        type: TableActions.SET_STATE,
        payload: {
          entity: entity,
          entityData: {
            newDataRequested: true,
          },
        },
      });
    }

    try {
      const listApi = entityMapper?.[entity]?.listApi;

      const res = await listApi(
        { page: pageNumber, page_size: count },
        apiProps
      );
      const tableModel = entityMapper?.[entity]?.dataObject;
      const sanitizedTableRes = new tableModel(res);

      if (res?.results) {
        dispatch({
          type: TableActions.SET_STATE,
          payload: {
            entity: entity,
            entityData: {
              toBeRetrieved: count,
              page: pageNumber,
              loading: false,
              currentSelectedColumn: undefined,
              tableData: sanitizedTableRes,
              newDataRequested: false,
            },
          },
        });
        onSuccess && onSuccess();
      } else {
        dispatch({
          type: TableActions.SET_STATE,
          payload: {
            entity: entity,
            entityData: {
              loading: true,
            },
          },
        });
      }
    } catch (err) {
      dispatch({
        type: TableActions.SET_STATE,
        payload: {
          entity: entity,
          entityData: {
            error: true,
            loading: false,
          },
        },
      });
    }
  };
};

export const updateSortByForTableThunk = ({
  entity,
  sort_by,
}: {
  entity: string;
  sort_by: {};
}) => {
  return async (dispatch: any) => {
    dispatch({
      type: TableActions.UPDATE_SORT_CONFIG,
      payload: {
        entity: entity,
        sort_by: sort_by,
      },
    });
  };
};

export const updateShowRecent = ({
  entity,
  showRecent,
}: {
  entity: string;
  showRecent: boolean;
}) => {
  return async (dispatch: any) => {
    dispatch({
      type: TableActions.UPDATE_SHOW_RECENT,
      payload: {
        entity: entity,
        showRecent: showRecent,
      },
    });
  };
};


export const updateWorkbenchData = (data: any) => ({

  type: "UPDATE_WORKBENCH_DATA",
  payload: data,
});
